// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"25":"254b949f","63":"8db7fdb7","289":"1b9c5112","334":"57a59aa6","365":"dd248ff2","834":"05e8d67d"}[chunkId] + ".js";
};